import React from 'react';

interface RevealProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: keyof JSX.IntrinsicElements;
  children: React.ReactNode;
}

// Thin wrapper that applies the `.reveal` class so initRevealOnScroll picks it
// up. The IntersectionObserver lives in website-runtime.ts; this component is
// purely declarative.
const Reveal: React.FC<RevealProps> = ({ as: As = 'div', className, children, ...rest }) => {
  const Tag = As as any;
  return (
    <Tag className={`reveal${className ? ' ' + className : ''}`} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
